import { render, staticRenderFns } from "./stock-list.vue?vue&type=template&id=c2df3a04&scoped=true"
import script from "./stock-list.vue?vue&type=script&lang=js"
export * from "./stock-list.vue?vue&type=script&lang=js"
import style0 from "./stock-list.vue?vue&type=style&index=0&id=c2df3a04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2df3a04",
  null
  
)

export default component.exports